export const companyInfo = {
  name: "Connect EDGE IT Services",
  tagline: "Professional On-Site IT Support & Infrastructure Solutions",
  phone: "312-392-8295",
  email: "support@connectedge.it.com",
  location: "Chicago, IL 60630",
  hours: "24/7 - 7 Days a Week",
  description: "Leading provider of on-site IT support, physical layer troubleshooting, and comprehensive installation services in the Chicago area."
};

export const services = [
  {
    id: 1,
    title: "Network Troubleshooting",
    shortDesc: "Expert diagnosis and resolution of network connectivity issues",
    description: "Our experienced engineers provide comprehensive network troubleshooting services to identify and resolve connectivity issues, latency problems, and performance bottlenecks. We work with all major network infrastructure brands and protocols.",
    features: [
      "Layer 1-3 troubleshooting",
      "Connectivity issue resolution",
      "Performance optimization",
      "Network diagnostics and testing"
    ]
  },
  {
    id: 2,
    title: "On-Site IT Support",
    shortDesc: "Dedicated technical support at your location",
    description: "We provide skilled IT professionals who arrive at your location to handle hardware installations, configurations, troubleshooting, and maintenance. Our on-site support ensures minimal downtime and maximum productivity.",
    features: [
      "Hardware installation and setup",
      "Configuration and testing",
      "Technical troubleshooting",
      "Preventive maintenance"
    ]
  },
  {
    id: 3,
    title: "Router/AP Replacement",
    shortDesc: "Professional installation of Cisco, Meraki, and enterprise-grade equipment",
    description: "Expert replacement and configuration of routers, access points, and network equipment. We specialize in Cisco, Meraki, and other enterprise-grade networking hardware with seamless migration and minimal service interruption.",
    features: [
      "Cisco & Meraki certified installations",
      "Configuration migration",
      "Zero-downtime deployment",
      "Post-installation testing"
    ]
  },
  {
    id: 4,
    title: "Data Center Dispatch",
    shortDesc: "Rapid response for data center operations and maintenance",
    description: "Specialized data center support services including equipment installation, maintenance, troubleshooting, and emergency response. Our engineers are experienced with data center protocols and security requirements.",
    features: [
      "Rack and stack services",
      "Equipment installation",
      "Cable management",
      "Environmental monitoring"
    ]
  },
  {
    id: 5,
    title: "Cable Installation & Testing",
    shortDesc: "Fiber, coax, and copper infrastructure deployment",
    description: "Professional installation and certification testing of fiber optic, coaxial, and copper cabling systems. We ensure proper termination, testing, and documentation for all structured cabling projects.",
    features: [
      "Fiber optic installation & splicing",
      "Coax and copper termination",
      "Cable certification testing",
      "Labeling and documentation"
    ]
  },
  {
    id: 6,
    title: "Installations & Configurations",
    shortDesc: "Complete infrastructure setup and optimization",
    description: "End-to-end installation and configuration services for network infrastructure, security systems, wireless networks, and more. We handle everything from planning to final testing and handoff.",
    features: [
      "Network infrastructure setup",
      "Security system installation",
      "Wireless network deployment",
      "System configuration and testing"
    ]
  },
  {
    id: 7,
    title: "Emergency Incident Response",
    shortDesc: "Critical P1/P0 emergency support available 24/7",
    description: "Immediate response for critical incidents with Priority 1 and Priority 0 severity. Our emergency response team is available 24/7/365 to minimize downtime and restore services quickly during critical outages.",
    features: [
      "24/7/365 emergency response",
      "P1/P0 incident handling",
      "Rapid on-site deployment",
      "Critical system recovery"
    ]
  }
];

export const aboutContent = {
  mission: "To deliver exceptional on-site IT support and infrastructure solutions that keep businesses connected and operational 24/7.",
  values: [
    {
      title: "Reliability",
      description: "Available 24/7 to ensure your critical systems stay online"
    },
    {
      title: "Expertise",
      description: "Certified engineers with deep knowledge of enterprise infrastructure"
    },
    {
      title: "Speed",
      description: "Rapid response times for emergency incidents and critical issues"
    },
    {
      title: "Quality",
      description: "Professional installations with proper testing and documentation"
    }
  ],
  whyChooseUs: [
    "Experienced engineers with enterprise-level expertise",
    "24/7 availability including emergency response",
    "Specialization in Cisco, Meraki, and major infrastructure brands",
    "Based in Chicago with rapid on-site response",
    "Comprehensive physical layer and infrastructure knowledge",
    "Proven track record in data center and enterprise environments"
  ]
};
